import { createContext, useReducer } from 'react'
import blogReducer from './BlogReducer'
import { getBlog, getBlogs, createBlog, updateBlog } from './BlogActions'
import BlogType from './BlogType'

const BlogContext = createContext()

export const BlogProvider = ({ children }) => {
  const initialState = {
    blogs: [],
    blog: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(blogReducer, initialState)

  const fetchBlogs = async (startupId) => {
    try {
      const blogsData = await getBlogs({
        startup: startupId,
      })
      dispatch({ type: BlogType.GET_BLOGS, payload: blogsData })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchBlog = async (id) => {
    try {
      const blogData = await getBlog(id)
      dispatch({ type: BlogType.GET_BLOG, payload: blogData })
    } catch (error) {
      console.log(error)
    }
  }

  const addBlog = async (blog) => {
    try {
      const blogData = await createBlog(blog)
      dispatch({ type: BlogType.CREATE_BLOG, payload: blogData })
    } catch (error) {
      console.log(error)
    }
  }

  const editBlog = async (id, blog) => {
    try {
      const blogData = await updateBlog(id, blog)
      dispatch({ type: BlogType.UPDATE_BLOG, payload: blogData })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <BlogContext.Provider
      value={{
        ...state,
        dispatch,
        fetchBlogs,
        fetchBlog,
        addBlog,
        editBlog,
      }}
    >
      {children}
    </BlogContext.Provider>
  )
}

export default BlogContext
